import { SiteLayout } from "@/components/site/SiteLayout";
import Hero from "@/components/Hero";
import CampingSites from "@/components/CampingSites";
import PlanVisit from "@/components/PlanVisit";
import ParkClosures from "@/components/ParkClosures";
import PackingList from "@/components/PackingList";
import FAQ from "@/components/FAQ";
import ImageGallery from "@/components/ImageGallery";
import AboutUs from "@/components/AboutUs";
import TourismInfo from "@/components/TourismInfo";
import ParquesTeaser from "@/components/ParquesTeaser";

/**
 * Home page (DESIGN.md). One long page on purpose (decided 2026-10-06), same
 * section order as before, plus the sticker row and the parks teaser. Each
 * section owns its id/anchor (#campsites, #cierres, #lista-equipaje, #faq,
 * #gallery, #about, #tourism-info).
 */
const Index = () => (
  <SiteLayout current="home">
    <Hero />
    <CampingSites />
    <PlanVisit />
    <ParkClosures />
    <PackingList />
    <FAQ />
    <ImageGallery />
    <AboutUs />
    <TourismInfo />
    <ParquesTeaser />
  </SiteLayout>
);

export default Index;
